
import {Component, Vue} from 'vue-property-decorator';
import SetTableColumns from "@/components/SetTableColumns.vue";
import OrganizationTable2 from "@/components/OrganizationTable2.vue";
import {IPage} from "@/js/page";
import { materialApi } from '@/api/material';
import {dictApi, mechanismNameApi} from "@/api/organization";
const {regionData, CodeToText} = require("@/js/region/region");
@Component({
  name: 'MaterialList',
  components: {SetTableColumns, OrganizationTable2}
})
export default class MaterialList extends Vue {
  CodeToText = CodeToText;
  regionData = regionData;
  private exportExcel: any;
  private closePage: any;
  screenHeight = document.documentElement.clientHeight; // 可见区域高度(应为body高度，可某些环境下无法获取)
  showForm = false;//查询条件隐藏展示
  load = false;//加载
  dataList = []; //数据列表
  tabCol = [];
  mechanismTypeList = [];
  mechanismDetail = { //单位详情
    visible: false,
    detail: null as any,
  }
  propParams = this.getPropParams();
  total = 0;
  listParam: IPage = {
    size: 50,
    current: 1,
  };
  orgNameDialog = {
    visible: false,
    dataList: []
  }
  getPropParams() {
    return {
      name: '',
      code: '',
      activeStatus: '',
      realName: '',
      region: ""  //区域
    }
  }

  created() {
    this.init();
  }

  reset() {
    this.propParams = this.getPropParams();
    this.refresh();
  }

  init() {
    const route = this.$route;
    const q = JSON.parse(JSON.stringify(route.query));
    if (q.size) {
      this.listParam.size = Number(q.size);
      this.listParam.current = Number(q.current);
    }
    this.listDict();
    this.loadData(null);
  }

  goMaterialList(orgId: string){
    const firstRouterText = this.$route.path.split("/")[1];
    this.$router.push("/" + firstRouterText + "/orgMaterialList/CUR/" + orgId);
  }

  loadData(callback: any) {
    const route = this.$route;
    let q = JSON.parse(JSON.stringify(route.query));
    q = Object.assign(q, this.listParam);
    for (const key in q) {
      q[key] = String(q[key]);
    }
    const args = {
      ...this.listParam,
      ...this.propParams,
    } as any;
    this.load = true;
    materialApi.pageMaterialOrg(args).then((r: any) => {
      if(r.data.result === 0){
        const rData = r.data.data.records;
        this.total = r.data.data.total;
        this.dataList = rData;
        if (callback) {
          callback();
        }
        this.$nextTick(() => {
          let $table = this.$refs.table as HTMLFormElement;
          if ($table) {
            $table.doLayout();
          }
          this.load = false;
        })
      }
    });
  }

  indexMethod(index: any) {
    return (this.listParam.current - 1) * this.listParam.size + index + 1;
  }

  changeTabCol(e: any) {
    this.tabCol = e;
    this.$nextTick(() => {
      let $table = this.$refs.table as HTMLFormElement;
      if ($table) {
        $table.doLayout();
      }
    })
  }
  refresh() {
    this.loadData(null);
  }
  pageSizeChange(val: number) {
    this.listParam.size = val;
    this.refresh();
  }
  pageCurrentChange(val: number) {
    this.listParam.current = val;
    this.loadData(null);
  }
  listDict() {
    //单位类别
    dictApi.listDictItem({typeCode: "dwlb"}).then((r) => {
      if (r.data.result === 0) {
        const dataList = r.data.data;
        this.mechanismTypeList = dataList;
      }
    });
  }
  closeModal() {
    this.mechanismDetail.detail = null;
    this.mechanismDetail.visible = false;
  }
  onExportExcel() {
    const loading = this.$loading({
      text: '正在导出Excel',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    const listParam = JSON.parse(JSON.stringify(this.listParam));
    this.listParam.size = this.total;    //将表格长度变成数据总长度
    this.listParam.current = 1;          //显示第一页
    this.loadData(() => {
      this.exportExcel(() => {
        this.listParam = listParam;    //表格长度还原
        this.loadData(null);
        loading.close();
      }, "标准物质生产单位管理列表.xlsx");
    });
  }

  closeOrgNameDialog(){
   this.orgNameDialog.visible = false;
   this.orgNameDialog.dataList = [];
  }
  showOrgName(orgId: number){
      mechanismNameApi.list({ownerId: orgId}).then(r=>{
        if (r.data.result === 0) {
          this.orgNameDialog.dataList = r.data.data;
          this.orgNameDialog.visible = true;
        }
      });
  }
}


